import type { SeloPremiadoItem } from "../../../services/seloPremiadoFornecedor"

export type { SeloPremiadoItem }

export type NovoSeloForm = {
    codigo: string
    titulo: string
    descricao: string
    maximo: string
    quantidadeAGerar: string
    valorDesconto: string
}

export const NovoSeloFormInicial: NovoSeloForm = {
    codigo: "",
    titulo: "",
    descricao: "",
    maximo: "1",
    quantidadeAGerar: "1",
    valorDesconto: "",
}

export type SeloPremiadoFornecedorModel = {
    selos: SeloPremiadoItem[]
    busca: string
    novoSelo: NovoSeloForm
}

export const SeloPremiadoFornecedorInicial: SeloPremiadoFornecedorModel = {
    selos: [],
    busca: "",
    novoSelo: NovoSeloFormInicial,
}
